import type { MouseEvent } from "react";

import { OPERATIONAL_MODULE_PATH_TO_KEY } from "./operationalModulePicker.helpers";

/** Intercepta cliques nos links operacionais da sidebar para abrir o modal sem trocar de rota. */
export const handleOperationalSidebarClick = (
  event: MouseEvent,
  openPicker: (moduleKey: string) => void,
) => {
  const anchor = (event.target as Element).closest("a[href]");
  if (!anchor) {
    return;
  }

  const href = anchor.getAttribute("href");
  const moduleKey = href ? OPERATIONAL_MODULE_PATH_TO_KEY[href] : undefined;
  if (!moduleKey) {
    return;
  }

  event.preventDefault();
  openPicker(moduleKey);
};
